/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */
import AdvertisementContainer from './Advertisement';

/**
 * Advertisement module exports
 */
export {
    AdvertisementContainer as default
};



// WEBPACK FOOTER //
// ./src/js/Advertisement/index.js